import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/table-row-background.ejs';
import contentTemplate2 from 'properties/style/table-row-background2.ejs';
import { pickerCfg } from 'pickerCfg.js';
import undoService from 'UndoService';
import themeService from 'ThemeService';
import util from 'util/Util.js';
import textConstants from 'TextConstants';
import mobileSyncService from "../../../service/mobile/MobileSyncService";

class StyleTableRowsBackgroundView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        if (this.model.get('factoryKey')!== 'control_table') {
            this.template = contentTemplate2;
        }
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes'
        };

        return this;
    }

    updateColorAttributes(ev){
        ev.preventDefault();
        let propName = ev.target.name;
        let propValue = ev.target.value;
        let oldNormalRowBgColor=this.model.get('normalRowBgColor');
        let oldAlternateRowBgColor=this.model.get('alternateRowBgColor');
        if (propName === 'tableRowColor1Picker') {
            this.model.set('normalRowBgColor', propValue);
            mobileSyncService.synchronize(this.model, {key: 'normalRowBgColor', val: propValue });
            if ( this.isThemeProperty(oldNormalRowBgColor) ){
                themeService.deattachTheme(this);
            }
        } else if (propName === 'tableRowColor2Picker') {
            this.model.set('alternateRowBgColor', propValue);
            mobileSyncService.synchronize(this.model, {key: 'alternateRowBgColor', val: propValue });
            if ( this.isThemeProperty(oldAlternateRowBgColor) ){
                themeService.deattachTheme(this);
            }
        }
       

        undoService.add({
            // PF-3465 Undo/Redo for Table Row Color Picker.
            undo: () =>{
                if (propName === 'tableRowColor1Picker') {
                    this.model.set('normalRowBgColor', oldNormalRowBgColor);
                } else if (propName === 'tableRowColor2Picker') {
                    this.model.set('alternateRowBgColor', oldAlternateRowBgColor);
                }
            },
            redo:() => {
                if (propName === 'tableRowColor1Picker') {
                    this.model.set('normalRowBgColor', propValue);
                } else if (propName === 'tableRowColor2Picker') {
                    this.model.set('alternateRowBgColor', propValue);
                }
            }
        },textConstants.UNDO_ROW_COLOR)
    }

    updateColorAttributesWithValidation  (ev){
        ev.preventDefault();
        let propName = ev.target.name;
        let propValue = ev.target.value;

        if (util.isValidColorcode(propValue)) {
            let oldNormalRowBgColor=this.model.get('normalRowBgColor');
            let oldAlternateRowBgColor=this.model.get('alternateRowBgColor');
            if (propName === 'tableRowColor1') {
                this.model.set('normalRowBgColor', propValue);
                if ( this.isThemeProperty(oldNormalRowBgColor) ){
                    themeService.deattachTheme(this);
                }
            } else if (propName === 'tableRowColor2') {
                this.model.set('alternateRowBgColor', propValue);
                if ( this.isThemeProperty(oldAlternateRowBgColor) ){
                    themeService.deattachTheme(this);
                }
            }

            // PF-3465 Undo/Redo for Table Row Color Text Field.
            undoService.add({
                undo: () =>{
                    if (propName === 'tableRowColor1Picker') {
                        this.model.set('normalRowBgColor', oldNormalRowBgColor);
                    } else if (propName === 'tableRowColor2Picker') {
                        this.model.set('alternateRowBgColor', oldAlternateRowBgColor);
                    }
                },
                redo:() => {
                    if (propName === 'tableRowColor1Picker') {
                        this.model.set('normalRowBgColor', propValue);
                    } else if (propName === 'tableRowColor2Picker') {
                        this.model.set('alternateRowBgColor', propValue);
                    }
                }
            },textConstants.UNDO_ROW_COLOR)
        }
    }

    render() {
        super.render();
        let props = this.resolveThemeColors(this.model, ['normalRowBgColor', 'alternateRowBgColor']);
        this.$el.html(this.template(props));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);
        this.delegateEvents();
        return this;
    }

}

export default StyleTableRowsBackgroundView;
